<template>
  <!-- The Replay button a story scene shows once its run has ended (composables/useStoryReplay).
       Sits in the scene's bottom-right corner; the scene keeps room for it in its padding.
       `tone="light"` is for scenes on a light background. -->
  <button type="button" class="srb" :class="`srb--${tone}`" aria-label="Replay preview" title="Replay preview">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" /></svg>
  </button>
</template>

<script setup>
defineProps({
  tone: { type: String, default: "dark" },
});
</script>

<style scoped>
.srb {
  position: absolute;
  right: 8px;
  bottom: 6px;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #a3a3a3;
  cursor: pointer;
}
.srb:hover { background: rgb(255 255 255 / 0.08); }
.srb:focus-visible { outline: 2px solid #67e8f9; outline-offset: 1px; }
.srb--light { color: #64748b; }
.srb--light:hover { background: rgb(15 23 42 / 0.06); }
.srb--light:focus-visible { outline-color: #0e7490; }
.dark .srb--light { color: #a3a3a3; }
.dark .srb--light:hover { background: rgb(255 255 255 / 0.08); }
.dark .srb--light:focus-visible { outline-color: #67e8f9; }
.srb svg { width: 20px; height: 20px; fill: currentColor; }
</style>
